import React from 'react'
import './ImageStyleSheet.css';

function RogerFive() {
    window.scrollTo(0,0);
    return (
        <div className="container">
            <img src="/images/roger5.jpeg" className='img-view'/>
        </div>
    )
}

export default RogerFive
